import React from 'react';
import { Input } from '@app/ui';

type TextFilterProps = {
    placeholder?: string;
    value?: string;
    onChange: (value: string) => void;
};

const inputStyles = { width: '90%' };

export const TextFilter = ({
    onChange,
    placeholder,
    value,
}: TextFilterProps) => {
    const handleChange = event => {
        onChange(event.target.value);
    };

    return (
        <Input
            size="middle"
            value={value ?? ''}
            onChange={handleChange}
            placeholder={placeholder}
            style={inputStyles}
            allowClear={false}
        />
    );
};

export default TextFilter;
